export default "__VITE_ASSET__74433f46__"